import { useEffect, useState } from "react";

interface ImageProps {
  image?: File;
}

export const Image = (props: ImageProps) => {
  const [preview, setPreview] = useState<string>();

  useEffect(() => {
    if (!props?.image) {
      setPreview(undefined);
      return;
    }

    const objectUrl = URL.createObjectURL(props?.image);
    setPreview(objectUrl);

    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [props.image]);

  return (
    <div>
      {props.image && <img src={preview} style={{ maxWidth: "100%" }} />}
    </div>
  );
};
